import { fg } from '@atlassian/jira-feature-gating';
import { getUpdateAnalyticsFlowHelper } from '@atlassian/jira-issue-analytics/src/services/update-issue-field/index.tsx';
import {
	FIX_VERSIONS_TYPE,
	VERSION_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { CardId } from '../../../../../../../model/types.tsx';

export const useVersionEndAnalytics = ({ selectedCardIds }: { selectedCardIds: CardId[] }) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return () => {
		if (!fg('one_event_rules_them_all_fg')) {
			return;
		}
		if (selectedCardIds.length !== 1) {
			return;
		}
		getUpdateAnalyticsFlowHelper().fireAnalyticsEnd(FIX_VERSIONS_TYPE, {
			analytics: createAnalyticsEvent({}),
			attributes: {
				fieldType: VERSION_CF_TYPE,
			},
		});
	};
};
